import { env, isDev } from '@/core/config/env';

/**
 * Solo activo si:
 * 1. Estamos en modo desarrollo (nunca en producción)
 * 2. La variable de entorno VITE_DISABLE_GUARDS=true está presente
 *
 * Aunque VITE_DISABLE_GUARDS esté en true, en un build de producción
 * isDev es false y el bypass nunca se activa.
 */
export function useGuardBypass(): boolean {
  if (!isDev) return false;

  return env.VITE_DISABLE_GUARDS === 'true';
}
